import { render, staticRenderFns } from "./MenuProduct.vue?vue&type=template&id=609d80df&scoped=true&"
import script from "./MenuProduct.vue?vue&type=script&lang=js&"
export * from "./MenuProduct.vue?vue&type=script&lang=js&"
import style0 from "./MenuProduct.vue?vue&type=style&index=0&id=609d80df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d80df",
  null
  
)

export default component.exports